import LZString from 'lz-string'

/**
 * compressToBase64 produces ASCII UTF-16 strings representing the original string encoded in Base64.
 * Can be decompressed with decompressFromBase64.
 * This works by using only 6bits of storage per character.
 * The strings produced are therefore 166% bigger than those produced by compress.
 * It can still reduce significantly some JSON compressed objects.
 */
export function compressToBase64(input: string): string {
  return LZString.compressToBase64(input)
}
export function decompressFromBase64(input: string): string {
  return LZString.decompressFromBase64(input)
}

/**
 * compressToUTF16 produces "valid" UTF-16 strings in the sense that all browsers can store them safely.
 * So they can be stored in localStorage on all browsers tested (IE9-10, Firefox, Android, Chrome, Safari).
 * Can be decompressed with decompressFromUTF16.
 * This works by using only 15bits of storage per character.
 * The strings produced are therefore 6.66% bigger than those produced by compress
 */
export function compressToUTF16(input: string): string {
  return LZString.compressToUTF16(input)
}
export function decompressFromUTF16(compressed: string): string {
  return LZString.decompressFromUTF16(compressed) || ''
}

/**
 * compressToUint8Array produces an uint8Array. Can be decompressed with decompressFromUint8Array.
 */
export function compressToUint8Array(uncompressed: string): Uint8Array {
  return LZString.compressToUint8Array(uncompressed)
}
export function decompressFromUint8Array(compressed: Uint8Array): string {
  return LZString.decompressFromUint8Array(compressed) || ''
}

/**
 * compressToEncodedURIComponent produces ASCII strings representing the original string encoded in Base64 with a few tweaks to make these URI safe.
 * Hence, you can send them to the server without thinking about URL encoding them.
 * This saves bandwidth and CPU. These strings can be decompressed with decompressFromEncodedURIComponent.
 */
export function compressToEncodedURIComponent(input: string): string {
  return LZString.compressToEncodedURIComponent(input)
}
export function decompressFromEncodedURIComponent(compressed: string): string {
  return LZString.decompressFromEncodedURIComponent(compressed) || ''
}

/**
 * compress produces invalid UTF-16 strings.
 * Those can be stored in localStorage only on webkit browsers (Tested on Android, Chrome, Safari).
 * Can be decompressed with decompress
 */
export function compress(input: string): string {
  return LZString.compress(input)
}
export function decompress(compressed: string): string {
  return LZString.decompress(compressed)
}
